export default "__VITE_ASSET__DW5VRxSz__"